import { Component, OnInit, Input } from "@angular/core";

import { Table } from "../../../../game/helpers/table";
import { NavTableData } from "../../../../../shared/models";
import { environment } from "../../../../../../environments/environment";
import { ConfigService } from "../../../../../core/services/config.service";
import { GenericTextArray } from "../../../../game/helpers/generic-text-array";
import * as PIXI from "pixi.js";
import { CurrencyPipe } from "../../../../../shared/utils/currency.pipe";
import { CurrencyDeviderPipe } from "../../../../../shared/utils/currency-devider.pipe";

@Component({
  selector: "app-nav-standard-table",
  templateUrl: "./nav-standard-table.component.html",
  styleUrls: ["./nav-standard-table.component.scss"],
})
export class NavStandardTableComponent implements OnInit {
  public environment = environment;
  @Input() navTable: NavTableData;
  tableText: string = "";
  config;
  constructor(private configService: ConfigService) {
    this.config = this.configService.config;
  }

  ngOnInit() {
    const currency = this.navTable?.table?.currency;
    if (this.navTable.table.tableSum) {
      const blindValue =
        this.navTable.table.IdTournament !== undefined
          ? this.navTable.table.tableSum.Blind
          : CurrencyPipe.prototype.transform(
              CurrencyDeviderPipe.prototype.transform(
                this.navTable.table.tableSum.Blind,
                currency,
              ),
              currency,
            );
      const blindValue2 =
        this.navTable.table.IdTournament !== undefined
          ? this.navTable.table.tableSum.Blind * 2
          : CurrencyPipe.prototype.transform(
              CurrencyDeviderPipe.prototype.transform(
                this.navTable.table.tableSum.Blind * 2,
                currency,
              ),
              currency,
            );

      const tableBlindsText = `Blinds: ${blindValue}/${blindValue2}`;
      this.tableText += tableBlindsText;
      if (this.navTable.table.tableSum.Ante > 0) {
        this.tableText += ` Ante: ${CurrencyPipe.prototype.transform(CurrencyDeviderPipe.prototype.transform(this.navTable.table.tableSum.Ante, currency), currency)}`;
      }

      if (this.navTable.table.tableSum.BringIn > 0) {
        this.tableText += ` Bring In: ${CurrencyPipe.prototype.transform(CurrencyDeviderPipe.prototype.transform(this.navTable.table.tableSum.BringIn, currency), currency)}`;
      }
    }
  }
}
